import { RESET_SCHEDULE_DATA, SCHEDULE_IS_LOADING, SCHEDULE_LOAD_ERROR, SCHEDULE_LOAD_SUCCESS } from "../actions/action_types";

export default function scheduleReducer(state = { scheduleData: null, isLoading: false, scheduleError: null }, action) {
    switch (action.type) {
        case SCHEDULE_IS_LOADING:
            return {...state, isLoading: true }
        case SCHEDULE_LOAD_SUCCESS:
            return {...state, scheduleData: action.payload, isLoading: false }
        case SCHEDULE_LOAD_ERROR:
            return {...state, scheduleError: action.payload, isLoading: false }
        case RESET_SCHEDULE_DATA:
            return {scheduleData: null, isLoading: false, scheduleError: null}
        default:
            return state
    }
}